import React from 'react';

import { Avatar, Box, Chip, Text, useTheme } from '@ublend-npm/aulaui-core';

import { DARK } from '@core/constants/theme';
import { DARK_THEME_RED_TEXT, LIGHT_THEME_RED_TEXT } from './types';

type ParticipantHistoryItemProps = {
  avatar?: string;
  isEducator: boolean;
  firstName: string;
  lastName: string;
  responsible: string;
  type: string;
};

const ParticipantHistoryItem = ({
  avatar,
  isEducator,
  firstName,
  lastName,
  responsible,
  type,
}: ParticipantHistoryItemProps) => {
  const theme = useTheme();

  const initials = `${firstName?.substring(0, 1) || ''}${
    lastName?.substring(0, 1) || ''
  }`;

  const textSx =
    type === 'removed'
      ? {
          color:
            theme.palette.mode === DARK
              ? DARK_THEME_RED_TEXT
              : LIGHT_THEME_RED_TEXT,
        }
      : {};

  return (
    <Box
      sx={{
        pt: 2,
        display: 'flex',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <Avatar
        src={avatar}
        fallbackText={initials}
        sx={{ width: 32, height: 32 }}
      />
      <Text>
        <span style={textSx}>
          {firstName} {lastName}
        </span>
        {isEducator ? (
          <Box sx={{ display: 'inline-block', mx: 1 }}>
            <Chip
              sx={{
                backgroundColor: theme.palette.secondary.main,
                cursor: 'default',
              }}
              kind="primary"
              size="small"
              label="Educator"
            />
          </Box>
        ) : (
          <span> </span>
        )}
        <span style={textSx}>
          was {type} by {responsible}
        </span>
      </Text>
    </Box>
  );
};

export default ParticipantHistoryItem;
